import { render, staticRenderFns } from "./PurchaseReturnDetailQuery.vue?vue&type=template&id=c6d35130"
import script from "./PurchaseReturnDetailQuery.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnDetailQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports